// extracted by mini-css-extract-plugin
export default {"MuiRating-icon":"CategoryBadge_MuiRating-icon__2xuGb","MuiRating-iconEmpty":"CategoryBadge_MuiRating-iconEmpty__fRpiH","badge":"CategoryBadge_badge__5iIJn"};